import colors from '../../colors';
import sizes from '../../sizes';
import fonts from '../../fonts';
import scrollbar from '../scrollbar';

const darkBase = {
    scrollbar,
    current: {
        text: {
            color: colors.primary300,
            ...fonts.text.sm.semiBold
        }
    },
    inactive: {
        text: {
            color: colors.coolGray400,
            ...fonts.text.sm.semiBold
        },
        hoverText: {
            color: colors.coolGray200,
            ...fonts.text.sm.semiBold
        },
        focusText: {
            color: colors.coolGray400,
            ...fonts.text.sm.semiBold
        }
    },
    disabled: {
        text: {
            color: colors.coolGray400,
            ...fonts.text.sm.semiBold,
            opacity: 0.5
        }
    },
    spacing: {
        default: 12,
        stretch: 32
    },
    gradient: {
        width: sizes.fixedSpacing['7xl'],
        height: sizes.fixedSpacing['4xl'],
        overlayHeight: 44,
        paddingRightInPx: sizes.fixedSpacing['3xl'],
        backgroundColor: colors.coolGray800,
        left: {
            background: 'linear-gradient(to left, rgba(36, 43, 44, 0.00) -8.11%, #242B2C 50%)'
        },
        right: {
            background: 'linear-gradient(to right, rgba(36, 43, 44, 0.00) -8.11%, #242B2C 50%)'
        }
    }
};

export default darkBase;
